/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import * as React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import ListIcon from '@material-ui/icons/List'
import { IHSFieldGroup } from '../../../models/HSFields'
import HSField, { fieldIsVisible } from './HSField'
import {
  IOneplaceLibraryContextProp,
  withOneplaceLibraryContext
} from '../../OneplaceLibraryProvider'
import { ISelectionLists } from '../../form_controls/types'
import { IHelpInfo } from '../../../models/CustomFields'
import { HazardAutoComplete } from '../../form_controls/HazardAutoComplete'
import { IIDAndName } from '../../..'

export interface IHSFieldGroupProps extends IOneplaceLibraryContextProp {
  group: IHSFieldGroup
  selectionLists: ISelectionLists
  values: { [fieldName: string]: any }
  helpInfos: IHelpInfo[]
  onFieldsChanged(values: { [fieldName: string]: any }): void
  isOffline: boolean
  hazardMenu: boolean
  accessHazard: boolean
}

const HSFieldGroup = withOneplaceLibraryContext((props: IHSFieldGroupProps) => {
  const visibleField = props.group.fields.find((field) =>
    fieldIsVisible(field, props.values)
  )
  if (!visibleField) {
    return null
  }

  const hazard = props.values?.hazard

  return (
    <Grid
      container
      spacing={2}
      key={props.group.label}
      style={{ marginBottom: 16 }}
    >
      <Grid item xs={12}>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap'
          }}
        >
          {props.ctx.i18next.t('customLabel_incident') === props.group.label ? (
            <>
              <ListIcon style={{ fontSize: '32px', marginRight: '5px' }} />
              <Typography variant='h5'>Details</Typography>
            </>
          ) : (
            <Typography variant='h5'>{props.group.label}</Typography>
          )}
        </div>
      </Grid>
      {props.group.fields.map((field) => {
        // skip rendering if the field is 'hazard' and hazardMenu is false
        if (field.name === 'hazard' && !props.hazardMenu) {
          return null
        }

        return (
          <React.Fragment key={field.name}>
            {field.name === 'hazard' &&
            (!field.visiField || props.values[field.visiField]) &&
            props.hazardMenu ? (
              <HazardAutoComplete<IIDAndName, number>
                initialSelection={hazard}
                selectionLists={props.selectionLists?.['hazardsList']}
                handleHazardChange={(_e, newHazard) => {
                  props.onFieldsChanged({
                    ...props.values,
                    hazard: newHazard || null
                  })
                }}
                getLabel={(o) => o.name}
                getValue={(o) => o.id}
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                mapResponse={(h) => ({ id: h.id, name: h.name })}
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                mapOfflineItem={(h) => ({ id: h.id, name: h.label })}
                isOffline={props.isOffline}
                disabled={field.readonly || !props.accessHazard}
              />
            ) : (
              <HSField
                field={field}
                selectionLists={props.selectionLists}
                values={props.values}
                helpInfos={props.helpInfos}
                onFieldsChanged={props.onFieldsChanged}
                addSpacing={field.type === 'TEXT_AREA'}
              />
            )}
          </React.Fragment>
        )
      })}
    </Grid>
  )
})

export default HSFieldGroup
